// extracted by mini-css-extract-plugin
export default {"row":"row--_LzdA","borderBefore":"borderBefore--Bqx5W"};